
import wx from 'weixin-js-sdk'

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'order',
directives: {
TransferDom
},
components: {
cmBlank,cmLoadmore,PopupPicker,Previewer,Popup,XButton,Radio, Group,PopupHeader,Checklist,XTextarea,Datetime
},
data () {
return {
title:'订单详情',
startDate:'',
minHour:6,
maxHour:20,
minuteList:['00','30'],
popBg:false,
timePop:false,
datetimeStatus:false,
uploadStatus:false,
isActive:0,
blankShow:false,
loadStatus:false,
showCommentStatus:false,
showResetStatus:false,
showCancelStatus:false,
rewardStatus:false,
addRemarkStatus:false,
rewardAmount:'',
loadmoreText:'正在加载。。。',
busy:false,
phone:'',
pageFlag:2,
hasNext:0,
lastId:0,
id:0,
itemId:0,
list:[
{
pics_path:[],
logs:[],
content:'',
create_time:'',
}
],
pickerGroupStatus:false,
pickerWorkerStatus:false,
isTransferOrder:false,
check:'/static/images/start@2x.png',
checked:'/static/images/started@2x.png',
group:[],
groupId:0,
worker:[],
workerId:[],
logs:[],
filePath:[],
pics:[],
isAssign:0,
grade:0,
itemIndex:0,
content:'',
commented:'',
home_time: '',
old_home_time: '',
remark: '',
}
},
created(){
this.id = Number(this.$route.params.id);
this.grade = parseInt(this.$func.getLocal('grade'));
this.getList();
this.curtainOrderLog();
this.setDate();
},
mounted(){
this.getCurtainGroup();
if(this.grade == 23){
this.getWorker();
}
this.config();
},
methods:{
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),

}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
},
datetimeChange(val){
this.home_time = val;
},
editHomeTime(id,index){
this.itemId = id;
this.home_time = this.list[index].home_time;
this.old_home_time = this.list[index].home_time;
this.popBg = true;
this.timePop = true;
},
submitEditHomeTime(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.home_time){
this.$func.showToast('请选择上门时间');
return false;
}
if(this.home_time == this.old_home_time){
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
return ;
}
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainEditHomeTime({id:this.itemId,home_time:this.home_time}).then((res)=>{
if(res){
this.$func.endLoading();
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
}else{
setTimeout(()=>{
window.location.reload();
},300)
}
}
});
})
},
payStatus(id){
this.$func.confirm('确认已付款？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainPayStatus({id:id}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
copy(val){
this.$func.copy(val,event);
},
reset(){
this.phone = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
selectStatus(key){
this.loadStatus = false;
this.where = [];
this.where['status'] = key;
this.isActive = key;
this.lastId = 0;
this.list = [];
this.getList();
},
getList(){
this.$api.getCurtainOrder({id:this.id}).then((res)=>{
if(res){

if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
this.list = res.data;
}
})
},
curtainOrderLog(){
this.$api.curtainOrderLog({id:this.id}).then((res)=>{
if(res){
this.logs = res.data;
}
})
},
changeStatus(id,status){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(status == 2 && !this.groupId){
this.$func.showToast('请选择拆装组');
return false;
}
if(status == 3 && !this.workerId.length){
this.$func.showToast('请选择拆装师傅');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.changeCurtainStatus({id:id,status:status,groupId:this.groupId,workerId:this.workerId,isTransferOrder:this.isTransferOrder ? 1 : 0}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
grabOrder(id){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认抢单？','提示',()=>{
this.$api.curtainGrabOrder({id:id}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
curtainOrderEdit(id){
this.$router.push({name:'createCurtainOrder',params:{id:id}})
},
assignGroup(id){
this.itemId = id;
this.pickerGroupStatus = true;
},
onGroupChange (value) {
this.groupId = value;
},
closePop(){
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = false;
this.pickerGroupStatus = false;
this.rewardStatus = false;
this.addRemarkStatus = false;
this.remark = '';
},




assignWorker(id,index){
this.itemId = id;
this.isAssign = 1;
this.editHomeTime(id,index);

},
onWorkerChange (value) {
this.workerId = value;
},
transferOrder(id){
this.itemId = id;
this.isTransferOrder = true;
this.getWorker();
this.popBg = true;
this.pickerWorkerStatus = true;
},
setReward(id,index){
this.itemId = id;
this.rewardAmount = 0;
this.itemIndex = index;
this.popBg = true;
this.rewardStatus = true;
},
getCurtainGroup() {
this.$api.getCurtainGroup({}).then((res)=>{
if(res){
this.group = res.data;
}
})
},
getWorker() {
this.$api.getCurtainWorker({}).then((res)=>{
if(res){
this.worker = res.data;
}
})
},
showComment(id){
this.itemId = id;
this.showCommentStatus = true;
},
submitComment(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入回访结果');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainComment({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
submitRemark(){
if(!this.id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.remark){
this.$func.showToast('请输入备注内容');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainRemark({id:this.id,remark:this.remark}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
resetCurtainOrderStatus(id){
this.itemId = id;
this.content = '';
this.showResetStatus = true;
},
submitReset(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单重置原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.resetCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
submitReward(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(this.rewardAmount <= 0){
this.$func.showToast('请输入佣金金额');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainReward({id:this.itemId,amount:this.rewardAmount}).then((res)=>{
if(res){
this.$func.endLoading();
setTimeout(()=>{
this.popBg = false;
this.rewardStatus = false;
this.list[this.itemIndex].amount = this.rewardAmount;
this.rewardAmount = 0;
this.itemIndex = 0;
}, 300);
}
})
})
},
cancelCurtainOrder(id){
this.itemId = id;
this.content = '';
this.showCancelStatus = true;
},
submitCancel(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单撤销原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.cancelCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"openLocation",
]
});
}
})
},
openLocation(info){
wx.openLocation({
latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
name: info.address, // 位置名
address: info.address, // 地址详情说明
scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
infoUrl: '' 
});
},
closeUpload(){
this.uploadStatus = false;
this.filePath = [];
this.pics = [];
},
submitUpload(){
let that = this;
that.$func.confirm('确认提交上传图片？','提示',()=>{
that.$api.submitCurtainUpload({id:that.id,pics:that.pics}).then((res)=>{
if(res){
that.uploadStatus = false;
that.filePath = [];
that.pics = [];
that.getList();
}
});
})

},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'curtain'}).then((res)=>{
if(res){
that.filePath.push(res.data.pathName);
that.pics.push(res.data.saveName);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(urls,url){
wx.previewImage({
current: url ? url : urls[0], // 当前显示图片的 http 链接
urls: urls 
});
},
delImg(index){
this.filePath.splice(index,1);
this.pics.splice(index,1);
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';

this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainOrderInfo.vue